import { Button } from "@shared/src/components/ui/button";
import { KYC_PAGE } from "@shared/src/config/page-links";
import { useHostStore } from "@shared/src/stores/useHostStore";

export function KycRestriction({ closeModal }: { closeModal: () => void }) {
  const { router } = useHostStore();
  return (
    <div className="text-center text-text-secondary space-y-4">
      <p>To ensure secure trading, please complete your KYC verification before proceeding with this action.</p>
      <div className="flex justify-center gap-3">
        <Button
          variant="tertiary"
          radius="full"
          onClick={() => {
            router.push(KYC_PAGE);
            closeModal();
          }}
        >
          Complete KYC
        </Button>
      </div>
    </div>
  );
}
